import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './store';
import { BrowserRouter as Router } from 'react-router';
import { CookiesProvider } from 'react-cookie';
import Spinner from './layout/spinner';
import './lang';
import './assets/css/bootstrap.min.css';
import './assets/css/style.css';
import './assets/css/dev-style.css';
import '../src/assets/css/style-variables.css';
import { env } from 'config/env';

const region = env.VITE_PORTAL_REGION;

const regionStyles = import.meta.glob('./assets/css/region/*.css');
const regionVariables = import.meta.glob('./assets/css/regionVariables/*.css');

if (region) {
  regionVariables[`./assets/css/regionVariables/${region}.css`]?.();
  regionStyles[`./assets/css/region/${region}-style.css`]?.();
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <Provider store={store}>
    <CookiesProvider>
      <Router>
        <App />
        <Spinner />
      </Router>
    </CookiesProvider>
  </Provider>,
);
